import {ComponentFactory, ComponentFactoryResolver, NgModule, inject} from '@angular/core';

import {ShepherdComponent} from './tour.component';


@NgModule({
    imports: [
        ShepherdComponent,
    ],
    providers: [],
    exports: [
        ShepherdComponent
    ]
})
export class TourModule {
    private resolver = inject(ComponentFactoryResolver);


    constructor() {
    }

    public resolveComponentFactory(): ComponentFactory<ShepherdComponent> {
        return this.resolver.resolveComponentFactory(ShepherdComponent);
    }
}
